module.exports = __webpack_public_path__ + "assets/images/Saiba-mais_cabra-cega_ff994b3395255fca320d0527e2100fc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-four/Saiba-mais_cabra-cega.png
// module id = 212
// module chunks = 0